import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-text">
        Sponsored by Literacy to Success, nonprofit    |     Empowered by Read 21
      </div>
    </div>
  );
};

export default Footer;
